import {Button, Modal} from "semantic-ui-react";
import React from 'react';
import {Route} from "react-router";

export default class Chooser extends React.Component
{
    constructor()
    {
        super();
        this.state={
            opened: true
        }
    }

    render()
    {
        return(
            <Modal dimmer={"inverted"} inverted basic defaultOpen={false} size='small' style={{textAlign: "center"}}>
                <Modal.Content>
                    <Button.Group>
                        <Route render={({ history}) => (
                        <Button color="green" style={{fontFamily: "frivola"}} size='massive' onClick={() => { history.push('/') }}>
                            č {'->'} c
                        </Button>
                        )} />

                        <Route render={({ history}) => (
                            <Button style={{fontFamily: "frivola"}}  size='massive' onClick={() => { history.push('/p') }}>
                                č {'->'} ч
                            </Button>
                        )} />
                    </Button.Group>
                </Modal.Content>
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/main/Chooser.js